import withAnalytics from '../../hocs/withAnalytics';

export const DivWithAnalytics = withAnalytics('div');
